/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { ProfilesPrimaryPathParams, ProfilesPrimaryResponse } from '../types/ProfilesPrimary'

/**
 * PATCH /:organisation/profiles/:profile/primary
 * @see backend/nexus/modules/Billing/Http/Controllers/ProfilesController.php ProfilesController::primary
 */
export async function profilesPrimary(
	organisation: ProfilesPrimaryPathParams['organisation'],
	profile: ProfilesPrimaryPathParams['profile'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<ProfilesPrimaryResponse>> {
	return axiosInstance.patch(`/${organisation}/profiles/${profile}/primary`, undefined, config)
}
